import type { ReactNode } from 'react';

export const symbol_space_bar: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-360q-24.75 0-42.37-17.63Q160-395.25 160-420v-150q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v150h520v-150q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v150q0 24.75-17.62 42.37Q764.75-360 740-360H220Z"
		/>
	</svg>
);
